// 从右往左书写的语言：阿拉伯语ar、希伯来语he、维吾尔语ug_cn
const rtlLocales = ['ar', 'he', 'ug_cn']

// 是否为从右往左书写的语言
export function isRTL(locale) {
  return rtlLocales.some(t => locale === t)
}

// 根据语言设置html的dir属性（文本方向)
export function setDir(locale) {
  if (isRTL(locale)) {
    document.body.dir = 'rtl'
  } else if (document.body.dir) {
    document.body.removeAttribute('dir')
  }
}

export function getCookie(name) {
  const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`)
  const arr = document.cookie.match(reg)
  if (arr) {
    return unescape(arr[2])
  }
  return null
}

export function setCookie(name, value) {
  document.cookie = `${name}=${escape(value)};`
}

export function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  } else {
    return null
  }
}